import Home from './Homepage';

// Required for dynamic import used by Webpack
export default Home;
